











import { Vue, Component, Prop } from 'vue-property-decorator';
import { DEFAULT_AVATAR } from '@/config/map.conf';

@Component
export default class UserAvatar extends Vue {
    @Prop({ default: '' })
    username: string;

    @Prop({ default: '' })
    displayName: string;

    @Prop({ default: DEFAULT_AVATAR })
    avatar: string;

    @Prop({ default: false })
    online: boolean;

    @Prop({ default: false })
    showOnline: boolean;

    @Prop({ default: '' })
    tooltipContent: string;

    defaultAvatar: string = DEFAULT_AVATAR;
}
